import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropZone from '@src/new-components/DropZone';
import sanitizeHtml from 'sanitize-html';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { IconButton, Stack } from '@mui/material';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import MicIcon from '@mui/icons-material/Mic';
import {
  MIN_DURATION,
  MAX_DURATION,
  MAX_SIZE,
  STEPS,
} from '@src/constants/instantVoiceCloning';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { ContentUpload } from './index.style';

const VoiceSampleUploader = ({ onSetFileUpload, onSetStep }) => {
  const { t } = useTranslation();
  const [errorUpload, setErrorUpload] = useState(null);

  const onDrop = (file) => {
    onSetFileUpload(file);
    onSetStep(STEPS.PREVIEW_AUDIO);
  };

  return (
    <DropZone
      accept=".wav,.mp3,.m4a"
      height={360}
      validatorKeys={['format', 'size', 'duration', 'noAudio']}
      onSetError={setErrorUpload}
      isError={!!errorUpload?.key}
      onDrop={onDrop}
    >
      <ContentUpload>
        <div style={{ marginBottom: '16px' }}>
          <IconButton>
            <AddCircleOutlineRoundedIcon sx={{ color: COLOR.indigoIcon }} />
          </IconButton>
        </div>
        <Typography
          component="p"
          variant="body-16-medium"
          color={COLOR.colorIcon}
        >
          {t('instantVoiceCloneV2')}
        </Typography>
        <div style={{ marginBottom: '24px', marginTop: '4px' }}>
          <Typography component="p" variant="body-14-regular">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(t('uploadFileDesscription')),
              }}
              style={{
                color: COLOR.descriptionUpload,
              }}
            />
          </Typography>
        </div>
        {errorUpload?.key && (
          <div style={{ marginBottom: '24px' }}>
            <Typography
              component="p"
              variant="body-14-regular"
              color={COLOR.errorDropZone}
            >
              {t(errorUpload.key, {
                fileName: errorUpload.fileName,
                minDuration: MIN_DURATION,
                maxDuration: MAX_DURATION,
                size: MAX_SIZE,
              })}
            </Typography>
          </div>
        )}

        <Stack direction="row" justifyContent="center" gap={2}>
          <CommonButton
            size="small"
            variant="outlined"
            startIcon={<CloudUploadRoundedIcon sx={{ fontSize: '24px' }} />}
            textProps={{
              variantText: 'body-14-bold',
              color: COLOR.darkBlue,
            }}
          >
            {t('uploadDocuments')}
          </CommonButton>
          <CommonButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onSetStep(STEPS.RECORD_AUDIO);
            }}
            variant="contained"
            startIcon={<MicIcon sx={{ fontSize: '24px' }} />}
            textProps={{
              variantText: 'body-14-bold',
              color: COLOR.darkBlue,
            }}
          >
            {t('recordAudio')}
          </CommonButton>
        </Stack>
      </ContentUpload>
    </DropZone>
  );
};

export default VoiceSampleUploader;
